import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const uploadCollateralApi = createAsyncThunk("uploadCollateral", async (formData) => {
    const response = await axiosInstance.post("/uploadcollateral", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
});

const uploadCollateralSlice = createSlice({
    name: "uploadCollateral",
    initialState: {
        uploadCollateral: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(uploadCollateralApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(uploadCollateralApi.fulfilled, (state, action) => {
                state.uploadCollateral = action.payload;
                state.loading = false;
            })
            .addCase(uploadCollateralApi.rejected, (state, action) => {
                state.errors = action.payload || action.error.message;
                state.loading = false;
            });
    },
});

export default uploadCollateralSlice.reducer;

